import React, { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { Modal, Box, Typography, Button } from "@mui/material";
import LanguageIcon from '@mui/icons-material/Language';
import {
  Search,
  ShoppingBasket,
  Menu,
  SquareUserRound,
  Info,
  
  Users,
  Handshake,
  BriefcaseBusiness,
} from "lucide-react";
import {
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AlgeriaCities } from "./AlgeriaCities";
import { useSelector } from "react-redux";
import { removeProduct } from "./state";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setLanguage } from "./langueslice";



function Navbar() {

const fraisLivraison = {
  "Alger": { domicile: 400, stopDesk: 250 },
  "Boumerdes": { domicile: 600, stopDesk: 300 },
  "Blida": { domicile: 600, stopDesk: 300 },
  "Tipaza": { domicile: 600, stopDesk: 300 },
  "Tizi Ouzou": { domicile: 700, stopDesk: 350 },
  "Médéa": { domicile: 700, stopDesk: 350 },
  "Bouira": { domicile: 700, stopDesk: 350 },
  "Béjaïa": { domicile: 800, stopDesk: 350 },
  "Skikda": { domicile: 800, stopDesk: 350 },
  "Sidi bel Abbas": { domicile: 800, stopDesk: 350 },
  "Sétif": { domicile: 800, stopDesk: 350 },
  "Relizane": { domicile: 800, stopDesk: 350 },
  "Oum El Bouaghi": { domicile: 800, stopDesk: 350 },
  "Oran": { domicile: 800, stopDesk: 350 },
  "M'Sila": { domicile: 800, stopDesk: 350 },
  "Mostaganem": { domicile: 800, stopDesk: 350 },
  "Mila": { domicile: 800, stopDesk: 350 },
  "Mascara": { domicile: 800, stopDesk: 350 },
  "Tissemsilt": { domicile: 800, stopDesk: 350 },
  "Tlemcen": { domicile: 800, stopDesk: 350 },
  "Chlef": { domicile: 800, stopDesk: 350 },
  "Constantine": { domicile: 800, stopDesk: 350 },
  "Batna": { domicile: 800, stopDesk: 350 },
  "Annaba": { domicile: 800, stopDesk: 350 },
  "Aïn Témouchent": { domicile: 800, stopDesk: 350 },
  "Ain Defla": { domicile: 800, stopDesk: 350 },
  "Bordj Bou Arreridj": { domicile: 800, stopDesk: 350 },
  "Jijel": { domicile: 850, stopDesk: 350 },
  "Tiaret": { domicile: 900, stopDesk: 350 },
  "Souk Ahras": { domicile: 900, stopDesk: 350 },
  "Tébessa": { domicile: 900, stopDesk: 350 },
  "Khenchela": { domicile: 900, stopDesk: 350 },
  "Guelma": { domicile: 900, stopDesk: 350 },
  "El Taref": { domicile: 900, stopDesk: 350 },
  "Saïda": { domicile: 900, stopDesk: 350 },
  "Biskra": { domicile: 1000, stopDesk: 500 },
  "Ouled Djellal": { domicile: 1000, stopDesk: 550 },
  "Djelfa": { domicile: 1000, stopDesk: 500 },
  "Laghouat": { domicile: 1000, stopDesk: 500 },
  "Ouargla": { domicile: 1100, stopDesk: 500 },
  "El Mghair": { domicile: 1100, stopDesk: 600 },
  "El Oued": { domicile: 1100, stopDesk: 500 },
  "Touggourt": { domicile: 1100, stopDesk: 500 },
  "Ghardaia": { domicile: 1100, stopDesk: 500 },
  "El Meniaa": { domicile: 1150, stopDesk: 550 },
  "El Bayadh": { domicile: 1200, stopDesk: 600 },
  "Naama": { domicile: 1200, stopDesk: 600 },
  "Béchar": { domicile: 1200, stopDesk: 600 },
  "Beni Abbas": { domicile: 1200, stopDesk: 750 },
  "Timimoune": { domicile: 1500, stopDesk: 700 },
  "Tindouf": { domicile: 1500, stopDesk: 700 },
  "Adrar": { domicile: 1500, stopDesk: 700 },
  "In Salah": { domicile: 1700, stopDesk: 900 },
  "Tamanrasset": { domicile: 1800, stopDesk: 1000 },
  "Illizi": { domicile: 2000, stopDesk: 1000 },
};


const [modeLivraison, setModeLivraison] = useState("domicile"); // ou "stopDesk"
const [prixLivraison, setPrixLivraison] = useState(null);



  const products = useSelector((state) => state.panier.value);
  const dispatch=useDispatch();
  let Total = products.reduce((acc, product) => acc + product.price, 0);
  const navigate = useNavigate();
  const [text, setText] = useState({ wilaya: "", commune: "", nom: "", telephone: "" });
  const [openMenu, setOpenMenu] = useState(false);
  const [openCart, setOpenCart] = useState(false); // État pour le Drawer du panier
  const [search,setSearch]=useState("");
  const [produit,setProduit]=useState([]) ;
  const langue = useSelector((state) => state.langue.value);
  const toggleDrawer = (setState, newOpen) => () => {
    if (!newOpen) {
      document.body.focus(); // Déplace le focus sur le body avant fermeture
    }
    setState(newOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".search-container")) {
        setSearch("");
      }
    };
  
    document.addEventListener("click", handleClickOutside);
  
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const menuItems = [
    { text: "À propos de nous", icon: <Info />, path: "/about" },
  ];

  const serviceItems = [
    { text: "Services clients", text_ar: "خدمات العملاء", icon: <Users />, path: "/services" },
    { text: "Employés", text_ar: "الموظفون", icon: <BriefcaseBusiness />, path: "/employees" },
    { text: "Partenaires", text_ar: "الشركاء", icon: <Handshake />, path: "/partners" },
  ];



  const sendMessageToTelegram = async (message) => {
    const botToken = import.meta.env.VITE_TELEGRAM_BOT_TOKEN; 
    const chatId = import.meta.env.VITE_TELEGRAM_CHAT_ID;
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
    try {
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chat_id: chatId,
          text: message,
        }),
      });

       window.fbq('track', 'Purchase', {
  currency: 'DZD',
  value: totalPrix,
  contents: [
    {
      id: product._id, // ou un SKU
      quantity: selectedWeight,
      item_price: productList,
    },
  ],
  content_type: 'product',
}); // Calcul du total incluant la livraison
    const totalPrix = Total + prixLivraison;

    // Format des produits pour Facebook Pixel
    const fbContents = products.map(prod => ({
      id: prod._id || prod.id || prod.name, // utiliser un identifiant unique ou nom
      quantity: 1, // ou la quantité réelle si dispo
      item_price: prod.price,
    }));

    window.fbq('track', 'Purchase', {
      currency: 'DZD',
      value: totalPrix,
      contents: fbContents,
      content_type: 'product',
    });


    } catch (error) {
      console.error("Erreur d'envoi Telegram :", error);
    }
  };


  const isFormValid = () => {
    return text.nom.trim() !== "" &&
           text.telephone.trim() !== "" &&
           text.wilaya.trim() !== "" &&
           text.commune.trim() !== "";
  };


  const [openConfirm, setOpenConfirm] = useState(false);

const handleConfirmOrder = () => {
  if (!isFormValid() || products.length === 0) {
    alert("❌ Veuillez remplir tous les champs et ajouter des produits.");
    return;
  }
  if (
    (text.telephone.length !== 9 && text.telephone.length !== 10) ||
    !text.telephone.startsWith("0")
  ) {
    alert("❌ Veuillez entrer un numéro de téléphone valide.");
    return;
  }
  setOpenConfirm(true); // Ouvre le modal de confirmation
};

const sendOrder = async () => {
  setOpenConfirm(false);

  let productList = products
    .map(
      (pro) =>
        `🛍 ${ pro.weight } ${pro.name} - ${pro.price} DA`
    )
    .join("\n");

  let message = `🚀 Nouvelle commande !\n👤 Client: ${text.nom}\n📞 Téléphone: ${text.telephone}\n📍 Adresse: ${text.commune}, ${text.wilaya}\n\n🛒 Produits:\n${productList}\n\n🚚 Livraison: ${modeLivraison === "domicile" ? "À domicile" : "Point relais"} (${prixLivraison} DA)\n\n💰 Total: ${Total + prixLivraison} DA\n✅ Statut: Confirmée`;

  try {
    await sendMessageToTelegram(message);
    alert("✅ Commande confirmée avec succès !");
  } catch (error) {
    alert("❌ Erreur lors de la confirmation de la commande !");
  }
};


 


  const getproducts = async () => {
    try {
      const response = await fetch("https://antar-5byu.onrender.com/getposts", {
        method: "GET",
      });

      if (!response.ok) {
        const errorResult = await response.json().catch(() => ({ message: "Unknown error" }));
        alert("Erreur: " + errorResult.message || "Échec de la récupération des produits.");
        return;
      }

      const result = await response.json();
      setProduit(result);
    } catch (error) {
      console.error("Erreur produit:", error);
      alert("Erreur: Une erreur s'est produite. Veuillez réessayer.");
    }
  };

  
  useEffect(() => {
    getproducts();
  }, []);
 

  useEffect(() => {
  if (text.commune && fraisLivraison[text.wilaya]) {
    const prix = fraisLivraison[text.wilaya][modeLivraison];
    setPrixLivraison(prix);
  } else {
    setPrixLivraison(null);
  }
}, [text.commune, modeLivraison]);




  return (
    <div  className="w-full bg-gray-300  shadow-md pb-2 lg:px-16 " dir="ltr">
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
  <Box sx={{ p: 4, bgcolor: "white", borderRadius: 2, mx: "auto", mt: 10, width: 400, textAlign: "center" }}>
    <Typography variant="h6" gutterBottom>
    {langue === "fr" ? "🛒 Confirmer la commande ?" : "🛒 تأكيد الطلب؟"}
    </Typography>
    <Typography variant="body1" sx={{ my: 2 }}>
    {langue === "fr"
          ? `Vous êtes sur le point de confirmer votre commande de `
          : `أنت على وشك تأكيد طلبك لعدد `}
        <b>{products.length}</b>
        {langue === "fr" ? ` produit(s) pour un total de ` : ` منتج(ات) بمبلغ إجمالي قدره `}
        <b>{Total + prixLivraison} DA</b>.
    </Typography>
    <Button onClick={sendOrder} variant="contained" color="success" sx={{ mr: 1 }}>
    {langue === "fr" ? "Confirmer ✅" : "تأكيد ✅"}
    </Button>
    <Button onClick={() => setOpenConfirm(false)} variant="outlined" color="error">
    {langue === "fr" ? "Annuler ❌" : "إلغاء ❌"}
    </Button>
  </Box>
</Modal>
      {/* Barre supérieure */}
      <div className="flex flex-row justify-between items-center h-16 px-6">
        {/* Icônes Menu & Recherche */}
        <div className="flex items-center gap-4">
          <div id="antar"
            className="flex flex-row font-bold items-center cursor-pointer text-gray-900 hover:text-gray-700 transition"
            onClick={toggleDrawer(setOpenMenu, true)}
          >
            <Menu className="mr-2" />
            {langue =="fr" ? "Menu":"القائمة"}
          </div>
        </div>

        {/* Logo */}
        <div onClick={()=>{navigate("/")}} className="flex flex-row items-center justify-center hover:cursor-pointer">
          <div id="antar" className="text-lg text-green-900 sm:text-3xl font-bold  ">Antar</div>
          <img className="sm:ml-3 sm:mr-3 h-12 w-16 sm:h-14 sm:w-20" src="https://res.cloudinary.com/dkxjl9qii/image/upload/v1740503127/posts/pdpxxw1jrpmejjaqy76u.png" alt="Antar Logo" />
          <div id="antar" className="text-lg sm:text-3xl font-bold text-green-900">Épices</div>
        </div>

        {/* Panier */}
        <div 
          className="relative cursor-pointer hover:opacity-80 transition"
          onClick={toggleDrawer(setOpenCart, true)}
        >
          <ShoppingBasket className="text-gray-900" />
          <div className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold shadow-md">
            {products.length}
          </div>
        </div>
      </div>

   

     {/* Drawer Menu à gauche */}
<Drawer anchor="left" open={openMenu} onClose={toggleDrawer(setOpenMenu, false)}>
  <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(setOpenMenu, false)}>
    <div className={`font-bold text-3xl text-green-900 my-4 mx-5 ${langue === 'ar' ? 'text-right' : ''}`}>
      Antar
    </div>
    <Divider />
    
    {/* Bouton pour changer la langue */}
    <ListItem disablePadding>
      <ListItemButton onClick={() => dispatch(setLanguage(langue === 'fr' ? 'ar' : 'fr'))}>
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText
  primary={langue === 'fr' ? 'Changer vers l’arabe' : 'التبديل إلى الفرنسية'}
  className={langue === 'ar' ? 'text-right font-bold' : ''}
/>
      </ListItemButton>
    </ListItem>
    
    <Divider />
    
    <List>
      {menuItems.map(({ text, icon, path }) => (
        <ListItem key={text} disablePadding>
          <ListItemButton onClick={() => navigate(path)}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText
              primary={langue === "fr" ? "A propos de nous" : "معلومات عنا"}
              className={langue === 'ar' ? 'text-right font-bold' : ''}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>

    <Divider />

    <List>
      {serviceItems.map(({ text, text_ar, icon, path }) => (
        <ListItem key={text} disablePadding>
          <ListItemButton onClick={() => navigate(path)}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={langue === "fr" ? text : text_ar} className={langue === 'ar' ? 'text-right' : ''} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  </Box>
</Drawer>


      {/* Drawer Panier à droite */}
      <Drawer anchor="right" open={openCart} onClose={toggleDrawer(setOpenCart, false)}>
        <Box  className='w-80 sm:w-96 lg:w-xl' role="presentation" >
          <div className="font-bold text-3xl text-green-900 my-4 mx-5">{langue === "fr" ? "Panier" : "عربة التسوق"}</div>
          <Divider />
          <List>
            <ListItem disablePadding>
            <div className="flex flex-col items-center m-auto justify-center">
            {products.length > 0 ? (
  products.map((product) => (
    <div
      key={product.id}
      className="flex flex-row items-center sm:text-xl lg:text-2xl justify-center m-auto mb-2 p-2 bg-gray-100 rounded-lg w-full max-w-md"
    >
      {/* Image du produit */}
      <img className="h-16 w-24 sm:h-24 sm:w-32 rounded-xl " src={product.image} alt={product.name} />
      
      {/* Détails du produit */}
      <div  className="ml-3 text-right">
        <p className="font-bold ">
        {product.name}  <span dir="ltr">{product.weight}</span> 
        </p>
        <p className="font-bold text-green-800">Prix: {product.price} DA</p>
      </div>

      {/* Bouton de suppression */}
      <button 
        onClick={() => dispatch(removeProduct(product.id))} 
        className="rounded-xl bg-red-600 px-4 py-2 ml-2 text-white font-bold shadow-md hover:bg-red-500 active:bg-red-700 transition-all duration-300 ease-in-out transform hover:scale-105"
      >
        <DeleteIcon/>
      </button>
    </div>
  ))
) : (
  <div className="text-center font-bold text-gray-500 text-lg my-4">
    {langue === "fr" ? "🛒 Le panier est vide" : "🛒 عربة التسوق فارغة"}
  </div>
)}
    </div>
            </ListItem>
            <Divider />
            <div className="flex flex-row font-bold text-3xl text-green-900 my-4 mx-5">
            <div >{langue === "fr" ? "Total" : "المجموع"}</div>
            <div className="m-auto text-gray-700">{Total + prixLivraison} DA</div>
            </div>
            <Divider />
            <div className="font-bold text-3xl text-green-900 mt-4 mx-5">{langue === "fr" ? "Confirmer ✅" : "تأكيد ✅"}</div>

            <div className="p-4 text-gray-900 bg-white min-h-screen">
  {/* Nom complet */}
  <label className="text-gray-900 text-xl mb-1">{langue === "fr" ? "Nom complet" : "الاسم الكامل"}</label>
  <input
    type="text"
    className="w-full bg-gray-200 text-gray-900 p-2 rounded-md"
    placeholder={langue === "fr" ? "Entrez votre nom complet" : "أدخل اسمك الكامل"}
    value={text.nom}
    onChange={(e) => setText({ ...text, nom: e.target.value })}
    required
  />

  {/* Téléphone */}
  <label className="block text-gray-900 text-xl mt-4 mb-1"> {langue === "fr" ? "Téléphone" : "رقم الهاتف"}</label>
<input
  type="Number"
  className="w-full bg-gray-200 text-gray-900 p-2 mb-4 rounded-md"
  placeholder={langue === "fr" ? "Entrez votre numéro" : "أدخل رقم الهاتف"}
  value={text.telephone}
  onChange={(e) => setText({ ...text, telephone: e.target.value })}
  pattern="^0\d{8,9}$"
  title={langue === "fr"
    ? "Le numéro doit commencer par 0 et contenir 9 ou 10 chiffres."
    : "يجب أن يبدأ الرقم بـ 0 ويتكون من 9 أو 10 أرقام."}
  required
/>


      {/* Sélection de la Wilaya */}
      <label className=" text-gray-900 text-xl mb-1 ">{langue === "fr" ? "Wilaya" : "الولاية"}</label>
      <select
        className="w-full bg-gray-200 text-gray-900 p-2 rounded-md"
        value={text.wilaya}
        onChange={(e) => setText({ ...text, wilaya: e.target.value, commune: "" })}
      >
        <option value="" disabled>{langue === "fr" ? "Choisir une wilaya" : "اختر ولاية"}</option>
        {[...new Map(AlgeriaCities.map((c) => [c.wilaya_name_ascii, c])).values()]
          .map((wilaya, index) => (
            <option key={index} value={wilaya.wilaya_name_ascii}>
              {wilaya.wilaya_name_ascii}
            </option>
          ))}
      </select>

      {/* Sélection de la Commune */}
      <label className="block text-gray-900 text-xl mt-4 mb-1">{langue === "fr" ? "Commune" : "البلدية"}</label>
      <select
        className="w-full bg-gray-200 text-gray-900 p-2 rounded-md"
        value={text.commune}
        onChange={(e) => setText({ ...text, commune: e.target.value })}
        disabled={!text.wilaya} // Désactive si aucune Wilaya sélectionnée
      >
        <option value="" disabled>{langue === "fr" ? "Choisir une commune" : "اختر بلدية"}</option>
        {AlgeriaCities
          .filter((c) => c.wilaya_name_ascii === text.wilaya)
          .map((commune, index) => (
            <option key={index} value={commune.commune_name_ascii}>
              {commune.commune_name_ascii}
            </option>
          ))}
      </select>
      <label className="block text-gray-900 text-xl mt-4 mb-1">
  {langue === "fr" ? "Mode de livraison" : "طريقة التوصيل"}
</label>
<select
  className="w-full bg-gray-200 text-gray-900 p-2 rounded-md"
  value={modeLivraison}
  onChange={(e) => setModeLivraison(e.target.value)}
>
  <option value="domicile">{langue === "fr" ? "À domicile" : "لمنزل"}</option>
 {text.commune == text.wilaya ? <option value="stopDesk">{langue === "fr" ? "Point relais" : "نقطة تسليم"}</option>:null}
</select>

{prixLivraison !== null && (
  <div className="mt-2 text-green-900 font-semibold">
    {langue === "fr"
      ? `Frais de livraison: ${prixLivraison} DA`
      : `سعر التوصيل: ${prixLivraison} دج`}
  </div>
)}
      <div disabled={products.length === 0 || !isFormValid()}
      onClick={handleConfirmOrder} 
      className={`p-2 font-bold rounded-xl text-center w-full mt-6
        ${products.length === 0 || !isFormValid() ? "bg-gray-400 cursor-not-allowed" : "bg-green-900 hover:bg-green-950 text-white"}`}
        >{langue === "fr" ? "Confirmation" : "تأكيد"}</div>

    </div>
          </List>
        </Box>
      </Drawer>

      {/* Champ de recherche */}
      {/* Champ de recherche */}
<div className="relative w-full flex justify-center">
<input
  dir={langue === "ar" ? "rtl" : "ltr"}
  onChange={(e) => setSearch(e.target.value)}
  type="text"
  placeholder={langue === "fr" ? "Rechercher..." : "بحث..."}
  className="rounded-full bg-gray-200 w-[95%] border text-gray-500 border-black h-8 px-4 outline-none focus:ring-2 focus:ring-black transition"
/>

  {search.length > 0 && (
    <div className="absolute search-container top-full left-1/2 -translate-x-1/2 w-[95%] min-w-[250px] bg-gray-300 shadow-lg border rounded-lg max-h-60 overflow-y-auto z-50">
      {produit
        .filter((p) => p.title.toLowerCase().includes(search.toLowerCase()))
        .map((p) => (
          <div 
          onClick={()=>{navigate(`/page/${p._id}`)}} 
          key={p._id} className="flex flex-row  items-center m-auto p-2 hover:bg-gray-100 cursor-pointer">
            <img src={p.picturePaths} alt="Image" className="rounded-sm h-10  w-16 object-cover" />
            
              <p className="text-gray-800 font-bold ml-8">{p.title}</p>
              <p className="text-green-700 text-sm font-bold ml-8">{p.prix} DA/Kg</p>
           
          </div>
        ))
      }

      {produit.filter((p) => p.title.toLowerCase().includes(search.toLowerCase())).length === 0 && (
        <p className="p-3 text-gray-500 text-center">Aucun produit trouvé</p>
      )}
    </div>
  )}
</div>
  </div>
  );
}

export default Navbar;
